import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="home-hero ch-hero-anim" aria-label="CofounderHubs">
      <div
        className="home-hero-media ch-hero-media"
        style={{ backgroundImage: 'url(/img/startup.png)' }}
        aria-hidden="true"
      />
      <div className="home-hero-veil" aria-hidden="true" />
      <div className="home-hero-inner">
        <p className="home-hero-brand ch-hero-brand">CofounderHubs</p>
        <h1 className="home-hero-line ch-hero-line">Build with the right people beside you</h1>
        <p className="home-hero-sub ch-hero-sub">
          A living hub where startups find co-founders, talent, capital curiosity, and open roles —
          without juggling five different networks.
        </p>
        <div className="home-hero-cta ch-hero-cta">
          <Link to="/search" className="home-btn home-btn-primary">
            Find people
          </Link>
          <Link to="/startup-jobs" className="home-btn home-btn-ghost">
            Browse jobs
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
